import { BlockTypes } from 'enum/block-type.enum'
import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { QuestionForm } from 'models/question.model'
import { IQuestionLikertModel } from 'models/questionLikert.model'

export const GET_EVALUATION_QUESTION = 'GET_EVALUATION_QUESTION'
export const GET_EVALUATION_QUESTION_SUCCESS = 'GET_EVALUATION_QUESTION_SUCCESS'
export const EVALUATION_QUESTION_LIKERT_CREATE =
  'EVALUATION_QUESTION_LIKERT_CREATE'
export const EVALUATION_QUESTION_LIKERT_CREATE_SUCCESS =
  'QUESTION_LIKERT_CREATE_SUCCESS'
export const EVALUATION_QUESTION_LIKERT_EDIT = 'EVALUATION_QUESTION_LIKERT_EDIT'
export const EVALUATION_QUESTION_LIKERT_DESTROY =
  'EVALUATION_QUESTION_LIKERT_DESTROY'

export interface QuestionLikertCreatePayload {
  questionData: QuestionForm
  id: number
  instanceId: number
}

export interface QuestionLikertEditPayload {
  questionData: QuestionForm
  id: number
  questionId: number
  instanceId: number
}

export const Actions = {
  questionGet: (questionId: number, type: string) =>
    createAction(GET_EVALUATION_QUESTION, { questionId, type }),
  questionGetSuccess: (data: any) =>
    createAction(GET_EVALUATION_QUESTION_SUCCESS, data),
  questionLikertCreate: (data: QuestionLikertCreatePayload) =>
    createAction(EVALUATION_QUESTION_LIKERT_CREATE, data),
  questionLikertSuccess: (
    data: IQuestionLikertModel<BlockTypes.BlockEvaluation>
  ) => createAction(EVALUATION_QUESTION_LIKERT_CREATE_SUCCESS, data),
  questionLikertEdit: (data: QuestionLikertEditPayload) =>
    createAction(EVALUATION_QUESTION_LIKERT_EDIT, data),
  questionLikertDestroy: (questionId: number) =>
    createAction(EVALUATION_QUESTION_LIKERT_DESTROY, questionId),
}

export type Actions = ActionsUnion<typeof Actions>
